import { render, staticRenderFns } from "./EventUsers.vue?vue&type=template&id=a4dfe642&scoped=true&"
import script from "./EventUsers.vue?vue&type=script&lang=js&"
export * from "./EventUsers.vue?vue&type=script&lang=js&"
import style0 from "./EventUsers.vue?vue&type=style&index=0&id=a4dfe642&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dfe642",
  null
  
)

export default component.exports